import React from 'react'

const Careers = () => {
  return (
    <div className="flex items-center justify-center"
    >Careers</div>
  )
}

export default Careers